import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Page from 'components/layout/Page';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { DEFAULT_ERROR_COMPONENT_HIDE_ERROR } from './ErrorComponent.constants';
import {
  StyledError,
  StyledErrorContent,
  StyledErrorMountains,
  StyledErrorShootingStar,
  StyledErrorStars
} from './ErrorComponent.styled';
import { ErrorComponentProps } from './ErrorComponent.types';

const ErrorComponent: React.FC<ErrorComponentProps> = ({
  errorCode,
  hideErrorCode = DEFAULT_ERROR_COMPONENT_HIDE_ERROR
}) => {
  // Hooks.
  const { t } = useI18n('errorPage');
  const { locale } = useRouter();

  // Helpers.
  const renderImage = (): JSX.Element | null =>
    errorCode === 404 ? (
      <img src={getPublicPath('/images/404/404-center.png')} alt="" />
    ) : null;

  // Render
  return (
    <Page topBarTransparent>
      <StyledError>
        <StyledErrorStars>
          <div>
            <StyledErrorShootingStar />
            <StyledErrorShootingStar />
            <StyledErrorShootingStar />
            <StyledErrorShootingStar />
            <StyledErrorShootingStar />
          </div>
        </StyledErrorStars>

        <StyledErrorContent>
          {!hideErrorCode && renderImage()}

          <Heading2
            style={{
              marginTop: hideErrorCode ? '10rem' : '0'
            }}
          >
            {t(`${errorCode}.heading`)}
          </Heading2>

          <p>{t(`${errorCode}.desc`)}</p>

          <Link href={getAppUrl(APP_URLS.home, locale)} passHref>
            <ButtonLink variant="primaryInverse" sizes="md">
              <FontAwesomeIcon icon={faHome} />
              <span>{t(`${errorCode}.cta`)}</span>
            </ButtonLink>
          </Link>
        </StyledErrorContent>

        {errorCode === 404 && (
          <StyledErrorMountains>
            <div className="left">
              <img
                src={getPublicPath('/images/404/mountain-left.svg')}
                alt=""
              />
            </div>
            <div className="right">
              <img
                src={getPublicPath('/images/404/mountain-right.svg')}
                alt=""
              />
            </div>
          </StyledErrorMountains>
        )}
      </StyledError>
    </Page>
  );
};

export default ErrorComponent;
